import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const inputStyle = {
  width: '100%', padding: '12px 14px', borderRadius: 8,
  background: '#0f1117', border: '1px solid #2a2d3e',
  color: '#e2e8f0', fontSize: 14, outline: 'none',
  boxSizing: 'border-box', fontFamily: 'inherit',
};

export default function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setStatus('error');
      setMessage('Les mots de passe ne correspondent pas.');
      return;
    }
    if (password.length < 8) {
      setStatus('error');
      setMessage('Le mot de passe doit faire au moins 8 caractères.');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus('success');
        setMessage(data.message);
      } else {
        setStatus('error');
        setMessage(data.error || 'Une erreur est survenue');
      }
    } catch {
      setStatus('error');
      setMessage('Erreur de connexion au serveur.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f1117', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 380, background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 16, padding: 40, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
          <p style={{ color: '#ef4444', marginBottom: 20 }}>Lien invalide ou manquant.</p>
          <button onClick={() => navigate('/forgot-password')} style={{ padding: '10px 24px', borderRadius: 8, background: '#41B073', border: 'none', color: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>
            Demander un nouveau lien
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f1117', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 380, background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 16, padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔒</div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#e2e8f0' }}>Nouveau mot de passe</h1>
          <p style={{ margin: '8px 0 0', color: '#64748b', fontSize: 14 }}>Choisissez un mot de passe d'au moins 8 caractères.</p>
        </div>

        {status === 'success' ? (
          <div>
            <div style={{ background: '#10b98120', border: '1px solid #10b98140', borderRadius: 8, padding: '14px 16px', color: '#10b981', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
              {message}
            </div>
            <button
              onClick={() => navigate('/login')}
              style={{ width: '100%', padding: 13, borderRadius: 8, background: '#41B073', border: 'none', color: '#fff', fontWeight: 600, fontSize: 15, cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Se connecter
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, color: '#94a3b8', marginBottom: 6, fontWeight: 500 }}>Nouveau mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                style={inputStyle}
                autoFocus
                required
              />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, color: '#94a3b8', marginBottom: 6, fontWeight: 500 }}>Confirmer le mot de passe</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="••••••••"
                style={inputStyle}
                required
              />
            </div>

            {status === 'error' && (
              <div style={{ background: '#ef444420', border: '1px solid #ef444440', borderRadius: 8, padding: '10px 14px', color: '#ef4444', fontSize: 13, marginBottom: 16 }}>
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: 13, borderRadius: 8, background: loading ? '#35956aaa' : '#41B073', border: 'none', color: '#fff', fontWeight: 600, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'background 0.2s' }}
            >
              {loading ? 'Enregistrement...' : 'Enregistrer le mot de passe'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
